<template>
  <div class="LessonLearningList">
    <AppHeader :content="content"></AppHeader>
    <AppBox>
      <XTable
          :api="getLearningInfoList"
          :state="lessonLearningList"
          :columns="columns"
          :firstColumn="firstColumn"
          :loading="lessonLearningListLoading"
          :tableSize="tableSize"
          :layout="layout"
          :max-height="maxHeight"
      ></XTable>
    </AppBox>
  </div>
</template>

<script>
import XTable from "@/components/XTable/index.vue";
import {mapActions, mapState} from "vuex";
import DateUtil from "@/utils/formatDate";
import AppHeader from "@/components/ui/AppHeader/index.vue";
import AppBody from "@/components/layout/AppBody.vue";
import AppBox from "@/components/ui/AppBox/index.vue";
import {LEARNING_STATES, LEARNING_STEP} from "@/utils/constants";

export default {
  name: "LessonLearningList",
  components: {AppBox, AppBody, AppHeader, XTable},
  data() {
    return {
      content: "学习记录",
      tableSize: "small",
      layout: "sizes, prev, pager, next",
      firstColumn: false,
      maxHeight: 650,
    };
  },
  created() {
    this.lessonLearningFilter.id = Number.parseInt(this.$Base64.decode(this.$route.params.userId));
  },
  computed: {
    ...mapState("administrativeCenter", ["lessonLearningList", "lessonLearningFilter", "lessonLearningListLoading"]),
    columns: function () {
      const self = this;
      const columns = [
        {
          prop: "lessonName",
          label: "课程名",
        },
        {
          prop: "lessonVersion",
          label: "课程版本",
          width: 50,
        },
        {
          prop: "version",
          label: "学习版本",
          width: 50,
        },
        {
          label: "状态",
          width: 100,
          render(h, scope) {
            return (
                <div>
                  <span>{LEARNING_STATES[scope.row.states]}</span>
                </div>
            );
          },
        },
        {
          label: "阶段",
          width: 100,
          render(h, scope) {
            return (
                <div>
                  <span>{LEARNING_STEP[scope.row.step]}</span>
                </div>
            );
          },
        },
        {
          label: "学习进度",
          width: 50,
          render(h, scope) {
            let result = 0;
            let total = scope.row.total;
            let finish = scope.row.finish;
            if (total) {
              finish = Math.min(total, finish);
              result = (100 * finish / total).toFixed(0);
            }
            return (
                <div>
                  <span>{result}</span>
                </div>
            );
          },
        },
        {
          prop: "score",
          label: "测试得分",
          width: 50,
        },
        {
          prop: "grade",
          label: "课程评分",
          width: 50,
        },
        {
          label: "开始学习",
          width: 150,
          render(h, scope) {
            return (
                <div>
                  <span>{self.formatDateYYYYMMDDHHmm(scope.row.createTime)}</span>
                </div>
            );
          },
        },
        {
          label: "最后学习",
          width: 150,
          render(h, scope) {
            return (
                <div>
                  <span>{self.formatDateYYYYMMDDHHmm(scope.row.updateTime)}</span>
                </div>
            );
          },
        },
      ];
      return columns;
    }
  },
  methods: {
    ...mapActions("administrativeCenter", ["getLearningInfoList"]),
    //   根据时间戳计算年龄
    formatAge(timestamp) {
      return DateUtil.calculateAgeFromTimestamp(timestamp);
    },
    //   根据时间戳计算日期
    formatDate(timestamp) {
      return DateUtil.formatDateFromTimestamp(timestamp);
    },
    //   根据时间戳计算日期
    formatDateYYYYMMDDHHmm(timestamp) {
      return DateUtil.formatDateCommitTimestamp(timestamp);
    },
  },
};
</script>

<style lang="scss" scoped>
.LessonLearningList {
  .appBox {
    min-height: calc(100vh - 155px);
  }
}
</style>
